'use client';

import { css } from '@mildang/styled-system/css';
import NotFoundErrorScreen from '@ui/components/screens/NotFoundErrorScreen';

// 없는 주소. 밀당 타깃은 FallbackPage, 그 밖의 타깃은 기존 화면(루트 레이아웃의 FallbackPageProvider 기준).
const rootStyle = css({ display: 'flex', flexDirection: 'column', minH: '100dvh' });

export default function NotFound() {
  return (
    <main className={rootStyle}>
      <NotFoundErrorScreen />
    </main>
  );
}
